import { z } from "zod";
export const signupBodySchema = z.object({
    email: z.string().email(),
    password: z.string().min(8).max(200),
    name: z.string().min(1).max(200).optional(),
});
export const loginBodySchema = z.object({
    email: z.string().email(),
    password: z.string().min(1).max(200),
});
export const profileUpdateBodySchema = z.object({
    name: z.string().min(1).max(200).nullable(),
});
export const changeEmailBodySchema = z.object({
    email: z.string().email(),
    currentPassword: z.string().min(1).max(200),
});
export const changePasswordBodySchema = z.object({
    currentPassword: z.string().min(1).max(200),
    newPassword: z.string().min(8).max(200),
});
export const deleteAccountBodySchema = z.object({
    currentPassword: z.string().min(1).max(200),
});
// Request a password-reset email. Always answered with a generic success
// (see docs/api.md) so the response can't be used to probe which emails
// have accounts.
export const forgotPasswordBodySchema = z.object({
    email: z.string().email(),
});
// Redeem a reset token (from the emailed link) and set a new password.
export const resetPasswordBodySchema = z.object({
    token: z.string().min(1),
    newPassword: z.string().min(8).max(200),
});
export const meResponseSchema = z.object({
    id: z.string(),
    email: z.string().email(),
    name: z.string().nullable(),
    // Operator privilege. Drives the frontend admin-nav link and route gate;
    // the server is the real boundary (every /admin route calls requireAdmin).
    isAdmin: z.boolean(),
    // ISO timestamp at which the current access cookie expires. The client uses
    // this to schedule a proactive refresh ~5 min before expiry; it's not a
    // security boundary — the server still enforces the cookie's own Max-Age.
    expiresAt: z.string().datetime(),
});
//# sourceMappingURL=auth.js.map